module.exports = __webpack_public_path__ + "img/dsci0108.7c3843fe.jpg";